// @flow
export { default } from './Button';
export { ButtonType } from './Button.types';
export type { Props } from './Button';



// WEBPACK FOOTER //
// ../react-lib/src/components/buttons/Button/index.js